export const Regex = {
  CODE: /^[0-9]{4}$/,
  DIGIT: /^[0-9]*$/,
  FLOAT_DIGIT: /^[0-9.,]*$/,
  MONEY_USD: /^[0-9.,$]*$/,
  PHONE: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
};
